<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'assessment.assignAssessmentform.title' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
      <button (click)="closeDialog()" mat-icon-button mat-dialog-close aria-label="Close Dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="mat-typography">
    <form [formGroup]="patientdetails" novalidate>
      <div class="form-wrapper">
        <div class="row" *ngIf="assignedRole == accountAdmin">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.center' | translate}}</label><span class="required">*</span>
              </div>
              <select class="form-control lang-dropdown" [(ngModel)]="selectedcenter" formControlName="center" (change)="onSelectCenter($event)">
                <option *ngFor="let l of centerData" [value]="l" [attr.data-label]="l">{{l}}</option>
              </select>
              <div *ngIf="f.center.invalid && (f.center.dirty || f.center.touched)" class="alert alert-danger">
                <div *ngIf="f.center.errors?.required">{{'assessment.assignAssessmentform.centerError1' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.doctorname' | translate}}</label><span class="required">*</span>
              </div>
              <select class="form-control lang-dropdown" [(ngModel)]="selecteddoctorName" formControlName="doctorName">
                <option *ngFor="let l of doctorListOptions" [value]="l.doctorId" [attr.data-label]="l.doctorId">{{l.doctorName}}</option>
              </select>
              <div *ngIf="f.doctorName.invalid && (f.doctorName.dirty || f.doctorName.touched)" class="alert alert-danger">
                <div *ngIf="f.doctorName.errors?.required">{{'assessment.assignAssessmentform.doctorNameError1' | translate}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.fname' | translate}}</label><span class="required">*</span>
              </div>
              <input type="text" maxlength="31" class="form-control" formControlName="firstName" (keydown.space)="$event.preventDefault()">
              <div *ngIf="f.firstName.invalid && (f.firstName.dirty ||
                f.firstName.touched)" class="alert alert-danger">
                <div *ngIf="f.firstName.errors?.required">{{'assessment.assignAssessmentform.fnameError1' | translate}}</div>
                <div *ngIf="f.firstName.errors?.minlength">{{'assessment.assignAssessmentform.fnameError2' | translate}}</div>
                <div *ngIf="f.firstName.errors?.maxlength">{{'assessment.assignAssessmentform.fnameError3' | translate}}</div>
                <div *ngIf="f.firstName.errors?.pattern">{{'assessment.assignAssessmentform.fnameError4' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.lname' | translate}}</label><span class="required">*</span>
              </div>
              <input type="text" maxlength="31" class="form-control" formControlName="lastName" (keydown.space)="$event.preventDefault()">
              <div *ngIf="f.lastName.invalid && (f.lastName.dirty ||
                f.lastName.touched)" class="alert alert-danger">
                <div *ngIf="f.lastName.errors?.required">{{'assessment.assignAssessmentform.lnameError1' | translate}}</div>
                <div *ngIf="f.lastName.errors?.minlength">{{'assessment.assignAssessmentform.lnameError2' | translate}}</div>
                <div *ngIf="f.lastName.errors?.maxlength">{{'assessment.assignAssessmentform.lnameError3' | translate}}</div>
                <div *ngIf="f.lastName.errors?.pattern">{{'assessment.assignAssessmentform.lnameError4' | translate}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.phone' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field">
                <div class="country-phone">
                  <mat-select class="form-control country-dropdown" name="dial_code" [(value)]="selectedcountry"
                    placeholder="countryCode" #select4 formControlName="countryCode">
                    <mat-select-trigger>
                      <!-- <img src="{{ selectedcountry?.image }}" style="width: 30px; height: 25px; margin-right: 8px;" /> -->
                      {{ selectedcountry}}
                    </mat-select-trigger>
                    <mat-select-filter *ngIf="select4.focused" [array]="countryDropdownOptions" (filteredReturn)="countryDropdownList =$event" [displayMember]="'displayName'"
                    placeholder="{{'reports.patientListReport.btnSearch' | translate}}"></mat-select-filter>
                    <mat-option *ngFor="let y of countryDropdownList; let i = index" [value]="y.dial_code">
                      <img [src]="y.image" alt="{{ y.name }}" style="width: 30px; height: 25px; margin-right: 8px;">
                      {{y.name}} ({{y.dial_code}})
                    </mat-option>
                  </mat-select>
                  <input type="text" maxlength="25" class="form-control phone" formControlName="phone" (keydown)="onKeydown($event)"
                    onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()"
                    (blur)="onClickOutside(true)" (click)="onClickOutside(false)">
                </div>

                <div *ngIf="f.phone.invalid && (f.phone.dirty || f.phone.touched)" class="alert alert-danger">
                  <div *ngIf="f.phone.errors?.required">{{'assessment.assignAssessmentform.phoneError1' | translate}}</div>
                  <div *ngIf="f.phone.errors?.minlength">{{'assessment.assignAssessmentform.phoneError2' | translate}}</div>
                  <div *ngIf="f.phone.errors?.maxlength">{{'assessment.assignAssessmentform.phoneError3' | translate}}</div>
                  <div *ngIf="f.phone.errors?.pattern?.requiredPattern">{{'assessment.assignAssessmentform.phoneError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.email' | translate}}</label>
              </div>
              <div class="input-field">
                <input type="email" maxlength="125" class="form-control" formControlName="emailId" (keydown)="changeField($event)"
                  (keydown.space)="$event.preventDefault()">
                <div *ngIf="((f.emailId.touched || f.emailId.dirty) && f.emailId.value != null && f.emailId.value != '' && f.emailId.errors != null)" class="alert alert-danger">
                  <div *ngIf="f.emailId.errors?.minlength">{{'assessment.assignAssessmentform.emailError2' | translate}}</div>
                  <div *ngIf="f.emailId.errors?.maxlength">{{'assessment.assignAssessmentform.emailError3' | translate}}</div>
                  <div *ngIf="f.emailId.errors?.pattern">{{'assessment.assignAssessmentform.emailError4' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.age' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field" style="display: flex;">
                <mat-select class="form-control" name="ageYears" formControlName="ageYears" [value]="ageYears" (selectionChange)="onSelectAge()">
                  <mat-select-filter [array]="searchYearOptions" (filteredReturn)="filteredYearList =$event"
                  placeholder="{{'assessment.assignAssessmentform.year' | translate}}"></mat-select-filter>
                  <mat-option *ngFor="let y of filteredYearList; let i = index" [value]="y">
                    {{y}}
                  </mat-option>
                </mat-select>
                &nbsp;
                <mat-select class="form-control" name="month" formControlName="ageMonth" [value]="ageMonth" (selectionChange)="onSelectAge()">
                  <mat-select-filter [array]="searchMonthOptions" (filteredReturn)="filteredMonthList =$event"
                  placeholder="{{'assessment.assignAssessmentform.month' | translate}}"></mat-select-filter>
                  <mat-option *ngFor="let m of filteredMonthList; let i = index" [value]="m">
                    {{m}}
                  </mat-option>
                </mat-select>
              </div>
              <div *ngIf="f.ageYears.invalid && f.ageMonth.invalid && ((f.ageYears.dirty && f.ageMonth.dirty ) || (f.ageYears.touched && f.ageMonth.touched))">
                <div class="alert alert-danger" *ngIf="f.ageYears.errors?.required && f.ageMonth.errors?.required">{{'assessment.assignAssessmentform.ageError1' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.gender' | translate}}</label><span class="required">*</span>
              </div>
              <div class="input-field gender">
                <mat-radio-group aria-labelledby="example-radio-group-label" class="option-group" [(ngModel)]="selectedOption" formControlName="gender">
                  <mat-radio-button class="options" value="1" selected>{{'assessment.assignAssessmentform.radio.label1' | translate}}</mat-radio-button>
                  <mat-radio-button  class="options" value="2">{{'assessment.assignAssessmentform.radio.label2' | translate}}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.height' | translate}} ({{'assessment.assignAssessmentform.cm' | translate}})</label><span class="required">*</span>
              </div>
              <input type="number" min="1" max="300" (keypress)="omit_special_char($event)" (input)="validateHeight($event)"
                class="form-control" formControlName="height" (keydown.space)="$event.preventDefault()">
              <div *ngIf="f.height.invalid && (f.height.dirty || f.height.touched)" >
                <div class="alert alert-danger" *ngIf="f.height.errors?.required">{{'assessment.assignAssessmentform.heightError1' | translate}}</div>
                <div class="alert alert-danger" *ngIf="f.height.errors?.min">{{'assessment.assignAssessmentform.heightError2' | translate}}</div>
                <div class="alert alert-danger" *ngIf="f.height.errors?.max">{{'assessment.assignAssessmentform.heightError3' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.weight' | translate}} ({{'assessment.assignAssessmentform.kg' | translate}})</label><span class="required">*</span>
              </div>
              <input type="number" class="form-control" formControlName="weight" min="1" max="999.99" step=".01"
                (keypress)="omit_special_char($event)" value="" (input)="validateInput($event)">
              <div *ngIf="f.weight.invalid && (f.weight.dirty || f.weight.touched)" class="alert alert-danger">
                <div *ngIf="f.weight.errors?.required">{{'assessment.assignAssessmentform.weightError1' | translate}}</div>
                <div *ngIf="iswightInvalid">{{'assessment.assignAssessmentform.weightError2' | translate}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.language' | translate}}</label><span class="required">*</span>
              </div>
              <select class="form-control lang-dropdown" [(ngModel)]="selectedLang" formControlName="langid">
                <option *ngFor="let l of languageData" [value]="l.langId" [attr.data-label]="l.languagecode">{{l.language}}</option>
              </select>
              <div *ngIf="f.langid.invalid && (f.langid.dirty || f.langid.touched)" class="alert alert-danger">
                <div *ngIf="f.langid.errors?.required">{{'assessment.assignAssessmentform.langError1' | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 input-field">
            <div class="input-wrapper">
              <div class="input-label">
                <label>{{'assessment.assignAssessmentform.visitReason' | translate}}</label>
              </div>
              <input type="text" maxlength="1001" class="form-control" formControlName="reasonofvisit" (keypress)="omit_special_char($event)">
              <div *ngIf="f.reasonofvisit.invalid && (f.reasonofvisit.dirty || f.reasonofvisit.touched) && !f.reasonofvisit.errors?.whitespace" class="alert alert-danger">
                <div *ngIf="f.reasonofvisit.errors?.minlength">{{'assessment.assignAssessmentform.visitReasonError1' | translate}}</div>
                <div *ngIf="f.reasonofvisit.errors?.maxlength">{{'assessment.assignAssessmentform.visitReasonError2' | translate}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">

    <button mat-flat-button (click)='onSubmit()' [disabled]="patientdetails.invalid || (this.data.row && (this.data.row.assessmentStatusId == 3 || this.data.row.assessmentStatusId == 2))"  mat-raised-button class="btn-primary">{{'assessment.confirmOtp.submit' | translate}}</button>
  </mat-dialog-actions>
</div>
